export const COUNTRIES = [
  {code:'US', value:'United States Of America'},
  {code:'CA', value:'Canada'}
]
